import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../api/apiSlice';
import { bulkOperationsApi } from '../api/bulkOperationsApi';
import { setupListeners } from '@reduxjs/toolkit/query';

import authReducer from './slices/authSlice';
import productsReducer from './slices/productsSlice';
import treesListReducer from './slices/treesListSlice';
import todoListReducer from './slices/todoListSlice';
import treeManagementReducer from './slices/treeManagementSlice';
import treeReferenceReducer from './slices/treeReferenceSlice';
import inviteReducer from './slices/inviteSlice';
import farmAttributeFormsReducer from './slices/farmAttributeFormsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    treesList: treesListReducer,
    todoList: todoListReducer,
    treeManagement: treeManagementReducer,
    treeReference: treeReferenceReducer,
    invite: inviteReducer,
    farmAttributeForms: farmAttributeFormsReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    [bulkOperationsApi.reducerPath]: bulkOperationsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(bulkOperationsApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
setupListeners(store.dispatch);
